module.exports = __webpack_public_path__ + "img/foto-manifiesto.f80e8216.jpg";